export var Piece;
(function (Piece) {
    Piece["SREL"] = "srel";
    Piece["SRED"] = "sred";
    Piece["SRFL"] = "srfl";
    Piece["SRFD"] = "srfd";
    Piece["SCEL"] = "scel";
    Piece["SCED"] = "sced";
    Piece["SCFL"] = "scfl";
    Piece["SCFD"] = "scfd";
    Piece["TREL"] = "trel";
    Piece["TRED"] = "tred";
    Piece["TRFL"] = "trfl";
    Piece["TRFD"] = "trfd";
    Piece["TCEL"] = "tcel";
    Piece["TCED"] = "tced";
    Piece["TCFL"] = "tcfl";
    Piece["TCFD"] = "tcfd";
})(Piece || (Piece = {}));
